// extracted by mini-css-extract-plugin
export default {"popoverHeaderMenu":"PopoverHeaderComponent_popoverHeaderMenu__KAqeF","popoverHeaderItem":"PopoverHeaderComponent_popoverHeaderItem__TybuL"};